const graphqlEndpoint =
  global.gon && global.gon.graphql_endpoint
    ? global.gon.graphql_endpoint
    : "/graphql";

export default graphqlEndpoint;
